module.exports = __webpack_public_path__ + "img/mail.7acf9515.png";